import type {
  ICertificateItem,
  ICertificateItemTemplate,
  ICertificateTemplate,
  IPublicCertificatePaymentContext,
} from '@share/common-types';

const mapCertificateItemToItemTemplate = (
  item: ICertificateItem,
  certificateTemplateId: string,
): ICertificateItemTemplate => ({
  id: item.id,
  type: item.type,
  name: item.name.trim() ? item.name : item.type,
  nights: item.nights,
  internalPrice: item.internalPrice ?? 0,
  publicPrice: item.publicPrice ?? 0,
  createdAt: item.createdAt,
  updatedAt: item.updatedAt,
  certificateTemplateId,
  description: '',
});

export function mapPublicPaymentContextToCertificateTemplate(
  context: IPublicCertificatePaymentContext,
): ICertificateTemplate {
  const createdAt = context.items[0]?.createdAt ?? new Date(0).toISOString();
  const itemTemplates: ICertificateItemTemplate[] = context.items.map((item) =>
    mapCertificateItemToItemTemplate(item, context.id),
  );

  return {
    id: context.id,
    name: context.name,
    internalNotes: '',
    validityMonths: context.validityMonths ?? 0,
    internalPrice: 0,
    marginPrice: 0,
    url: '',
    createdAt,
    code: '',
    isLive: true,
    totalPrice: context.totalPrice,
    itemTemplates,
    selectedClubSiteIds: [],
    allowAllClubSites: true,
    averageRetailPrice: 0,
    savings: 0,
    imageUrl: context.imageUrl,
    descriptionContent: context.descriptionContent,
    eligibleCruiseLines: context.eligibleCruiseLines,
    termsAndConditionsContent: context.termsAndConditionsContent,
  };
}
